module.exports = __webpack_public_path__ + "static/media/usedmachineryformimage.e5c54ca8.jpg";